import React from 'react';
import PropTypes from 'prop-types';

import { WHITE } from '@constant/colors';

const DownloadArrow = ({ className, color }) => (
  <svg className={className} viewBox="0 0 14 14">
    <path
      d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0zm.759 3.705c0-.39-.342-.705-.763-.705-.424 0-.763.316-.763.705v4.876l-1.93-1.79a.809.809 0 0 0-1.078.002.669.669 0 0 0-.002.999l3.24 3.003A.79.79 0 0 0 7 11a.78.78 0 0 0 .54-.205l3.24-3.003a.673.673 0 0 0-.002-.999.803.803 0 0 0-1.077-.001l-1.941 1.8V3.704z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

DownloadArrow.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

DownloadArrow.defaultProps = {
  color: WHITE,
};

export default DownloadArrow;
